var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mine"},[_c('MinePane',{attrs:{"mine-data":_vm.mineData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }